import React, {useCallback} from 'react'

import {palette} from 'styled-tools'
import styled from 'styled-components'
import {SearchResponse} from '@algolia/client-search'

import {SearchType} from '@festi/common/utils/tagmanager'

import {WordSuggestion} from 'src/components/search/redesign/utilites/quickSearch'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const HitBox = styled.div`
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.4rem;
  padding: 0 10px;
  color: ${palette('blue')};
  background-color: ${palette('white')};
  text-transform: lowercase;
  cursor: pointer;

  &.active {
    display: none;
    cursor: default;
  }

  b {
    font-weight: 300;
    color: ${palette('blue')};
  }
`

interface Props {
  suggestionResults?: SearchResponse<WordSuggestion>
  handleClose?: () => void
  handleSubmitQuery: (query: string, type: SearchType) => void
}

export default function SuggestionHits({
  suggestionResults,
  handleClose,
  handleSubmitQuery,
}: Props) {
  const query = suggestionResults?.query

  const handleSearch = useCallback(
    (term: string, type: SearchType) => {
      !!handleClose && handleClose()
      handleSubmitQuery(term, type)
    },
    [handleClose, handleSubmitQuery],
  )

  return (
    <Wrapper>
      {suggestionResults?.hits?.map((hit) => (
        <HitBox
          key={hit.objectID}
          tabIndex={0}
          onClick={() => {
            handleSearch(hit.query, 'query_suggestion')
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSearch(hit.query, 'query_suggestion')
            }
          }}
          className={hit.query === query ? 'active' : ''}
        >
          {hit._highlightResult?.query?.value ? (
            <div
              dangerouslySetInnerHTML={{
                __html: hit._highlightResult.query.value,
              }}
            />
          ) : (
            hit.query
          )}
        </HitBox>
      ))}
    </Wrapper>
  )
}
